import cx from 'classix'
import type { ReactNode } from 'react'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'

import { CloseModal } from '../../CloseModal/CloseModal'
import styles from '../ModalHeader.module.css'
import { HeadersTitles } from './HeaderTitles/HeaderTitles'

export function CompleteHeader({
	title,
	close,
	subtitle,
	showBar,
	showHeaderSeparator,
	showTitle,
	hasSheetTitle,
	showClose,
	preventClose,
	hasCenteredTitle,
	className,
}: {
	readonly title: string
	readonly showBar: boolean
	readonly showHeaderSeparator: boolean
	readonly showTitle: boolean
	readonly hasSheetTitle: boolean
	readonly showClose: boolean
	readonly preventClose: boolean
	readonly hasCenteredTitle: boolean
	readonly subtitle?: string | ReactNode
	readonly close: () => void
	readonly className?: string
}) {
	return (
		<header
			className={cx(
				className,
				styles.header,
				applyStylesIf(showHeaderSeparator && showTitle, styles.withSeparator),
				applyStylesIf(showTitle, styles.withTitle)
			)}
		>
			{showBar && (
				<CloseModal preventClose={preventClose} close={close} asBar />
			)}
			<div className={styles.positionAnchor}>
				<HeadersTitles
					title={title}
					subtitle={subtitle}
					hasSheetTitle={hasSheetTitle}
					hasCenteredTitle={hasCenteredTitle}
					showTitle={showTitle}
					className={cx(
						applyStylesIf(
							showClose && !hasCenteredTitle,
							styles.withCloseButton
						)
					)}
				/>
				{showClose && (
					<CloseModal
						preventClose={preventClose}
						close={close}
						margin={hasCenteredTitle}
					/>
				)}
			</div>
		</header>
	)
}
